import semver from "semver";
import _ from "lodash";

import config from "../../config";
import { redirectRoute } from '../helpers';
import { translate as t } from '../../lib/I18n';
import { deviceDetection } from '../../helpers/DeviceDetection';
import { standardizeVersion } from '../../helpers/InAppHelpers';
import { GlobalModals, InAppPages } from '../../constants/AppConstants';
import InAppActions from '../../actions/InAppActions';
import ModalActions from "../../actions/ModalActions";
import FeatureFlagStore from "../../stores/FeatureFlagStore";

let holdAppVersion; // Store the appVersion from the query between the calls

export default {
    path: '/in-app',
    name: 'tab',

    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/inApp/Handler').default);
        }, 'inapp-handler');
    },

    indexRoute: redirectRoute(null, InAppPages.REDIRECT, { splat: 'search' }),

    getChildRoutes(location, cb) {
        require.ensure([], (require) => {
            cb(null, [
                require('./Redirect').default,
                require('./Search').default,
                require('./SeasonSearch').default,
                require('./RegisterSmartcard').default,
                require('./OneClickDelayRepay').default,
                require('./AutoDelayRepay').default,
                require('./Login').default,
                require('./Logout').default,
                require('./Account').default,
                require('./AccountOrdersRefunds').default,
                require('./Register').default,
                require('./Results').default,
                require('./SeasonResults').default,
            ].filter((x) => !!x));
        }, 'inapp-routes');
    },

    onEnter (nextState) {
        const {
            appVersion: queryAppVersion,
            channel,
            deviceToken,
            disableAutoLogout,
            disableAccountNavigationLogout,
        } = nextState.location.query;
        const enableAppUpdateAlertPopup = FeatureFlagStore.get('enableAppUpdateAlertPopup');
        let appVersion;

        if (queryAppVersion) {
            // This is a workaround for onEnter executing twice in a desktop browser.
            // On the second invocation the location.query is empty which sets the
            // appVersion to null.
            holdAppVersion = queryAppVersion;
        }

        appVersion = holdAppVersion;

        InAppActions.startSession({
            appVersion,
            deviceToken,
            channel,
            disableAutoLogout: disableAutoLogout === 'true',
            disableAccountNavigationLogout: disableAccountNavigationLogout === 'true'
        });

        if (appVersion) {
            const appVersionFull = standardizeVersion(appVersion);

            /* eslint-disable-next-line no-console */
            console.log('MOBILE APP VERSION: ', appVersionFull);

            if ((!semver.valid(appVersionFull) || semver.satisfies(appVersionFull, config.get('unsupportedAppVersions')[deviceDetection()])) && enableAppUpdateAlertPopup) {
                _.defer(() => {
                    ModalActions.open(GlobalModals.INFO, {
                        type: 'warning',
                        title: 'inApp.updateRequired',
                        message: t(`inApp.${deviceDetection()}UpdateMessage`),
                        hideClose: true,
                        disableEscape: true,
                        disableBlur: true
                    });
                });
            }
        }
    }

};
